import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zonas, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [canal, setCanal] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  async function listBureaus() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id,
      deleted_at: 'null',
      state: 'A'});
    if (response.success) setBureaus(response.data);
  }

  async function listCanales() {
    let response = await wsGetAll('sale/canal-incentivo');
    if (response.success) setCanal(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
      listZones();
      listBureaus();
      listCanales();
    }
  }, [props.model]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setBureaus([]);
      listBureaus();
    }
  }, [dataChanging.base_zone_id]);


  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/cuotas-incentivos'
        dataForce={{
          type: dataChanging.type,
          state: dataChanging.state,
          base_bureau_id: dataChanging.base_bureau_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={zonas}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zona (Para cambiar la mesa, no actualizable)" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_zone_id', item?.id);}}
          value={zonas.find((zona) => zona.id === dataChanging.base_zone_id) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={bureaus}
          getOptionLabel={(option) => `${option.description}`}
          value={
            bureaus.find(
              (item) =>
                String(item.id) === String(dataChanging.base_bureau_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Mesas" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange("base_bureau_id", item.id);
          }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Canal</InputLabel>
          <Select
            required
            value={ dataChanging.base_canal_id}
            inputProps={{
              name: 'base_canal_id',
              onChange: (e) => handleChange('base_canal_id', e.target.value),
            }}
          >
            {canal.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Cuota sin igv"
          fullWidth
          type="number"
          name="cuota_sin_igv"
          margin="normal"
          value={dataChanging.cuota_sin_igv || ''}
          onChange={(e) => {
            const value = parseFloat(e.target.value) || 0;
            handleChange('cuota_sin_igv', value);
            handleChange('cuota_month_percent', (value * 0.55).toFixed(2));
          }}
        />
        <TextField
          label="Cuota total"
          fullWidth
          type="number"
          name="cuota_total"
          margin="normal"
          value={dataChanging.cuota_total || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue === '') {
              handleChange('cuota_total', '');
              return;
            }
            const max = parseFloat(dataChanging.cuota_sin_igv) || 0;
            const numericValue = parseFloat(newValue);
            if (!isNaN(numericValue) && numericValue <= max) {
              handleChange('cuota_total', numericValue);
            }
          }}
          required
        />
        <TextField
          label="Cuota mensual al 55%"
          fullWidth
          type="number"
          name="cuota_month_percent"
          margin="normal"
          value={dataChanging.cuota_month_percent || ''}
          disabled
        />
      </Modal>
    </>
  );
}
